import AjaxURL from '../common/AjaxURL';

const gdprErrorMessageId = 'gdpr-error-message';
const inputError = 'm-private-input--error';
const inputValid = 'm-private-input--valid';
const errorMessageHide = 'm-desc-error--hide';
const birthErrorMessage = 'birthdate-error-message';

function SetInputValidity(containerId, classToAdd, classToRemove, isInvalid) {
  const errorMessageContainer = document.getElementById(gdprErrorMessageId);
  const errorMessageBirth = document.getElementById(birthErrorMessage);
  const $parentSelect = $('.m-private-input--birthday');
  const $listBdSelect = $parentSelect.find('select');

  containerId.attr('aria-invalid', isInvalid)
  .addClass(classToAdd)
  .removeClass(classToRemove);

  const valueSelect = [];
  $listBdSelect.each((i, el) => {
    if ($(el).val() !== '') {
      valueSelect.push(el);
    }
  });

  if (isInvalid === true && valueSelect.length === 3) {
    errorMessageContainer.classList.remove(errorMessageHide);
    errorMessageBirth.classList.add(errorMessageHide);
  } else if (isInvalid === true && valueSelect.length !== 3 && valueSelect.length > 0) {
    errorMessageContainer.classList.add(errorMessageHide);
    errorMessageBirth.classList.remove(errorMessageHide);
  } else {
    errorMessageContainer.classList.add(errorMessageHide);
    errorMessageBirth.classList.add(errorMessageHide);
  }
}

function GDPRBirthdateValidation(containerId, dayValue, monthValue, yearValue, isBirthDayRequired) {
  let isMinor = true;
  const day = Number(dayValue);
  const month = Number(monthValue);
  const year = Number(yearValue);
  if (isBirthDayRequired && day === 0 && month === 0 && year === 0) {
    SetInputValidity(containerId, inputError, inputValid, true);
    return isMinor;
  }
  if (day < 0 || month < 0 || year < 0) {
    SetInputValidity(containerId, inputError, inputValid, true);
    return isMinor;
  }
  if ((day === 0 || month === 0 || year === 0) && ((day !== month) || (year !== day) || (year !== month))) {
    SetInputValidity(containerId, inputError, inputValid, true);
    return isMinor;
  }
  $.ajax({
    url: AjaxURL.gdprAjax,
    dataType: 'json',
    data: { day: dayValue, month: monthValue, year: yearValue },
    type: 'post',
    async: false,
    success: function success(result) {
      if (Object.prototype.hasOwnProperty.call(result, 'isMinor')) {
        isMinor = result.isMinor;
      }
      if (isMinor === true) {
        SetInputValidity(containerId, inputError, inputValid, true);
      } else {
        SetInputValidity(containerId, inputValid, inputError, false);
      }
    }
  });
  return isMinor;
}

export default {
  GDPRBirthdateValidation,
};



// WEBPACK FOOTER //
// ./js/plugins/gdpr_birthdate_validation.js